<div class="column" [id]="entity().id" [attr.data-raw-id]="entity().id">
    <div
        [id]="entity().id"
        cdkDropList
        cdkDropListOrientation="horizontal"
        [cdkDropListAutoScrollStep]="25"
        [cdkDropListData]="entity().children"
        [cdkDropListConnectedTo]="connectedTo()"
        (cdkDropListDropped)="dropWidget($event)"
        style="width: 100%"
    >
        @if (!entity().children.length) {
            <div class="widget-empty-state" (click)="addWidget(blockHasLogo())">
                <div>
                    <div class="add-icon">
                        <span class="sp-icon icon-plus-add"> </span>
                    </div>
                </div>
            </div>
        }

        <div
            #animatedElem
            [id]="entity().id"
            [style.--column-justify]="justify()"
            [style.--column-align]="align()"
            [style.--column-text-align]="textAlign()"
            [style.--column-narrow-align]="narrowJustify()"
            [style.--column-narrow-text-align]="narrowTextAlign()"
        >
            <div class="specific-column-inner">
                <div class="specific-column-widgets-list specific-widget-list">
                    @for (widget of entity().children; track widget.id; let i = $index) {
                        @if (isWidgetVisible(widget)) {
                            <web-specific-widget
                                [index]="i"
                                [widget]="widget"
                                [column]="entity()"
                                [blockId]="block().id"
                                [widgetErrors]="widgetErrorsById(widget.id)"
                                [blockHasLogo]="blockHasLogo()"
                            />
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>
